import { useCallback, useMemo } from 'react'
import { generateClient } from 'aws-amplify/api'

import { getMyActiveClients as getMyActiveClientsQuery } from '../graphql/queries'
import { updateClient as updateClientMutation } from '../graphql/mutations'

export const useClient = () => {
  const client = useMemo(() => generateClient(), [])
  const getMyActiveClients = useCallback(
    (teamId, year, clientId) => {
      let input = { teamId, year }

      if (clientId !== undefined) {
        input = { ...input, clientId }
      }
      return client.graphql({
        query: getMyActiveClientsQuery,
        variables: { ...input },
      })
    },
    [client],
  )

  const updateClient = useCallback(
    (input) => {
      return client.graphql({
        query: updateClientMutation,
        variables: { ...input },
      })
    },
    [client],
  )

  return {
    getMyActiveClients,
    updateClient,
  }
}
